module.exports = __webpack_public_path__ + "img/Fehlertyp4_Dok2.6a058a33.jpg";